import React from 'react';
import Select from 'react-select';

import FieldLabel from '../../FieldLabel/FieldLabel';
import ColorPicker from '../../ColorPicker/ColorPicker';
import { fontsOptions } from '../../../constants/fontOptions';
import { getDefaultStyles } from '../../../helpers/getDefaultStyles';
import { Tooltip } from '../../UI/Tooltip/Tooltip';
import Icon from '../../UI/Icon/Icon';

import './ThemeSettings.sass';

export const ThemeSettings = ({ theme, handleChangeSetting }) => {
  const { fontFamily } = getDefaultStyles(document.getElementById('body'));

  return (
    <article className='theme-settings'>
      <h3 className='theme-settings__subtitle'>
        Color settings
        <Tooltip
          className="add-event__tooltip"
          description="These settings will affect colors on 'Slug' and 'Offer' pages."
        >
          <Icon name="info" />
        </Tooltip>
      </h3>

      {/* <FieldLabel className='control-field' label='Font family'>
        <Select
          options={fontsOptions}
          value={
            fontsOptions.find(
              ({ value }) => value === theme.fontFamily
            ) || { value: fontFamily, label: fontFamily }
          }
          onChange={(value) => {
            handleChangeSetting('fontFamily', value.value);
          }}
          classNamePrefix='custom-select'
          className='custom-select'
        />
      </FieldLabel> */}

      <FieldLabel className='control-field' label='Primary color'>
        <ColorPicker
          colorShowType={'circle'}
          value={theme.primaryColor}
          onChange={(color) => handleChangeSetting('primaryColor', color)}
          inputType='input'
          resetDefaultButton={false}
        />
      </FieldLabel>

      <FieldLabel className='control-field' label='Primary semi-light color'>
        <ColorPicker
          colorShowType={'circle'}
          value={theme.primarySemiLightColor}
          onChange={(color) => handleChangeSetting('primarySemiLightColor', color)}
          inputType='input'
          resetDefaultButton={false}
        />
      </FieldLabel>

      <FieldLabel className='control-field' label='Secondary color'>
        <ColorPicker
          colorShowType={'circle'}
          value={theme.secondaryColor}
          onChange={(color) => handleChangeSetting('secondaryColor', color)}
          inputType='input'
          resetDefaultButton={false}
        />
      </FieldLabel>

      <FieldLabel className='control-field' label='Secondary text color'>
        <ColorPicker
          colorShowType={'circle'}
          value={theme.secondaryTextColor}
          onChange={(color) => handleChangeSetting('secondaryTextColor', color)}
          inputType='input'
          resetDefaultButton={false}
        />
      </FieldLabel>
    </article>
  )
}
